/* src/app/features/contratacao/cancelamento/cancelamento-detalhe.component.scss */
.moeda {
  text-align: right;
}
/*# sourceMappingURL=cancelamento-detalhe.component.css.map */
